var _path, _path2, _path3;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgStatusIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0.5 7.99805C0.5 8.66109 0.763392 9.29697 1.23223 9.76581C1.70107 10.2347 2.33696 10.498 3 10.498C3.66304 10.498 4.29893 10.2347 4.76777 9.76581C5.23661 9.29697 5.5 8.66109 5.5 7.99805C5.5 7.33501 5.23661 6.69912 4.76777 6.23028C4.29893 5.76144 3.66304 5.49805 3 5.49805C2.33696 5.49805 1.70107 5.76144 1.23223 6.23028C0.763392 6.69912 0.5 7.33501 0.5 7.99805Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.5 7.99805C7.5 8.52848 7.71071 9.03719 8.08579 9.41226C8.46086 9.78733 8.96957 9.99805 9.5 9.99805C10.0304 9.99805 10.5391 9.78733 10.9142 9.41226C11.2893 9.03719 11.5 8.52848 11.5 7.99805C11.5 7.46761 11.2893 6.95891 10.9142 6.58383C10.5391 6.20876 10.0304 5.99805 9.5 5.99805C8.96957 5.99805 8.46086 6.20876 8.08579 6.58383C7.71071 6.95891 7.5 7.46761 7.5 7.99805Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M13.5 7.99805C13.5 8.26326 13.6054 8.51762 13.7929 8.70515C13.9804 8.89269 14.2348 8.99805 14.5 8.99805C14.7652 8.99805 15.0196 8.89269 15.2071 8.70515C15.3946 8.51762 15.5 8.26326 15.5 7.99805C15.5 7.73283 15.3946 7.47848 15.2071 7.29094C15.0196 7.1034 14.7652 6.99805 14.5 6.99805C14.2348 6.99805 13.9804 7.1034 13.7929 7.29094C13.6054 7.47848 13.5 7.73283 13.5 7.99805Z",
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStatusIcon);
export default __webpack_public_path__ + "static/media/Status_icon.bc79a25b.svg";
export { ForwardRef as ReactComponent };